import { AxiosResponse } from "axios";
import { QueryClient, useMutation, useQuery, useQueryClient } from "react-query";
import { IChangePasswordFormValues } from "../../components/global/Modal/ChangePasswordModal";
import { APILoginAuth, APILogoutAuth, IAPILoginAuthProps, APIFarmBookLoginAuth, APIChangePassword } from "../../service/api/APIAuth";

export enum EQueryAuthen {
    GetAuth = 'GetAuth',
    LoginAuth = 'LoginAuth',
    ChangePassword = 'ChangePassword',
    FarmBookLoginAuth = 'FarmBookLoginAuth',
    LogoutAuth = 'LogoutAuth'
}

export function useLoginAuth(){
    return useMutation<AxiosResponse,Error,IAPILoginAuthProps>(EQueryAuthen.LoginAuth, APILoginAuth)
}

export function useFarmBookLoginAuth(){
    return useMutation<AxiosResponse,Error,IAPILoginAuthProps>(EQueryAuthen.FarmBookLoginAuth, APIFarmBookLoginAuth)
}

export function useChangePassword(){
    return useMutation<AxiosResponse,Error,IChangePasswordFormValues>(EQueryAuthen.ChangePassword, APIChangePassword)
}

export function useLogoutAuth(){
    useMutation(EQueryAuthen.LoginAuth, () => APILogoutAuth())
}
